import ShiftSlotItemContainer from "./ShiftSlotItemContainer";

export default ShiftSlotItemContainer;
